// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iqpuBPSRgp54GF {
  display: block;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.iqpuBPSRgp54GF a {
  color: var(--ds-text-subtle, #44546f);
  cursor: pointer;
}
.cMjKAsoVQYsKab {
  display: inline-block;
}
`, ""]);
// Exports
export var timestamp = `iqpuBPSRgp54GF`;
var _1 = `cMjKAsoVQYsKab`;
export { _1 as "timestamp-inline" };
export default ___CSS_LOADER_EXPORT___;
